import {useQuery} from 'react-query';
import {RightsApi} from '../api';
import {useAppConfig} from '@mc/react-app-base';

export const CACHE_KEY_PRIRAZENA_APLIKACE = 'CACHE_KEY_PRIRAZENA_APLIKACE';

export const useMamPrirazenouAplikaci = () => {
    //@ts-ignore
    const {serverPublic} = useAppConfig();
    return useQuery<boolean>([CACHE_KEY_PRIRAZENA_APLIKACE], async () => (await RightsApi.mamPrirazenouAplikaci()).data, {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchInterval: false,
        enabled: !serverPublic,
    });
};
